/**
 * Address autocomplete (Azure Maps, proxied via the API). Returns no
 * suggestions when the provider key isn't configured — the UI just shows a
 * plain text field in that case.
 */
import { useQuery } from '@tanstack/react-query';
import type { AddressSearchResponse } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

export function useAddressSearch(query: string) {
  const q = query.trim();
  return useQuery<AddressSearchResponse>({
    queryKey: ['geo', 'address-search', q],
    enabled: q.length >= 3,
    staleTime: 5 * 60 * 1000,
    queryFn: () =>
      apiCall<AddressSearchResponse>(`/geo/address-search?q=${encodeURIComponent(q)}`),
  });
}
